import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import { Button, Col, Container, Form, Row } from "react-bootstrap";

/**
 * Dropdown that allows to select multiple items. Select choices are not applied until the Apply button is pressed.
 */
export const FilterMinMax = ({ showFilter, setShowFilter, option, filterMinMaxOptions, updateFilterOptions }: any) => {

    const wrapperRef: any = useRef(null);

    const [localMin, setLocalMin] = useState<any>(filterMinMaxOptions["min"]);
    const [localMax, setLocalMax] = useState<any>(filterMinMaxOptions["max"]);

    useEffect(() => {
        function handleClickOutside(event: any) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowFilter(false);
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    return (
        <div ref={wrapperRef} style={{float: 'left'}}>
            <Button className="cohort-filter-btn" variant={(filterMinMaxOptions["min"] || filterMinMaxOptions["max"]) ? "secondary" : "outline-secondary"} size="sm" onClick={() => setShowFilter(true)}>
                {option} {(filterMinMaxOptions["min"] || filterMinMaxOptions["max"]) ? (
                    <>
                        {filterMinMaxOptions["min"] ? filterMinMaxOptions["min"] : "N/A"} - {filterMinMaxOptions["max"] ? filterMinMaxOptions["max"] : "N/A"}
                    </>
                ) : <></>}{' '}<FontAwesomeIcon icon={faCaretDown} />
            </Button>
            {showFilter && (
                <>
                    <div className="cohort-filter-container" style={{ maxWidth: '240px', padding: '12px'}}>
                        <Container className="p-0">
                            <Row style={{marginBottom: '12px'}}>
                                <Col md={6}>
                                    <h6>Min</h6>
                                    <Form.Control type="number" name='min' value={localMin} onChange={(event: any) => {setLocalMin(event.target.value)}} />
                                </Col>
                                <Col md={6}>
                                    <h6>Max</h6>
                                    <Form.Control type="number" name='max' value={localMax} onChange={(event: any) => {setLocalMax(event.target.value)}} />
                                </Col>
                            </Row>
                            <Row className="pt-2 pb-1" style={{ marginRight: '1px' }}>
                                <Col md={12}>
                                    <div className="float-end">
                                        <Button variant="secondary" size="sm" onClick={() => { updateFilterOptions(option, {
                                            "min": localMin === "" ? null : localMin,
                                            "max": localMax === "" ? null : localMax,
                                        }); setShowFilter(false) }}>Apply</Button>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </>
            )}
        </div>
    );
};
